import { defineComponent as _defineComponent } from 'vue'
import { watch } from "@nuxtjs/composition-api";

import { useAmplitude, useTranslate, useVuetify } from "@/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductFeedSearch',
  props: {
  value: { type: String, required: true },
},
  emits: ["input"],
  setup(__props, { emit: emits }) {

const props = __props;



const { t } = useTranslate();
const amplitude = useAmplitude();

const vuetify = useVuetify();

const placeholder = t("Search all products");

const onInput = (value: string | null) => {
  emits("input", value ?? "");
};

const onFocus = () => {
  amplitude?.sendEvent("/ltk-keyword-search-shop/begin", {
    "referring-component": "creator shop product feed",
    "creator-shop-tab": "products",
  });
};

watch(
  () => props.value,
  (_newTerm, _oldTerm) => {
    if (process.server) {
      return;
    }

    const tabNavigation = 48;
    const searchInputDesktop = 84;
    const productsFeedTop = (document.querySelector("#product-feed") as HTMLElement)?.offsetTop ?? 0;
    const scrollTargetTop = vuetify.breakpoint.mdAndUp
      ? productsFeedTop + tabNavigation + searchInputDesktop
      : productsFeedTop + tabNavigation;
    window.scrollTo({ top: scrollTargetTop });
  },
);

return { __sfc: true,props, t, amplitude, emits, vuetify, placeholder, onInput, onFocus }
}

})